import React from "react";
import Templateemail from "./templateemail";
import TemplateResponse from "./templateResponse";
import { Redirect } from "react-router";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Switch, Route, Link, BrowserRouter, } from "react-router-dom";
import GlobalApi from "./../../Global"

import Colors from "./../../Global/colors"
import Spinner from "./../../Global/Spinner"
const AntTabs = withStyles({
  root: {
    backgroundColor: "#ffffff",
    color: "#222",
  },
  indicator: {
    backgroundColor: "#37baef",
  },
})(Tabs);
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
    
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: Colors.backgroundColor,
  },
}));

export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [permissions, setPermissions] = React.useState(null)
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    fetchpermissions()
  }, []);



  function fetchpermissions() {
    let localstorage = localStorage.getItem("UserData");
    if (localstorage === null) {
      return;
    }
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      user_id: data.user_id,
    };
    //console.log(params);
    //console.log(this.props.state.id)
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_user_permissions?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response);
        if (response.status == "Success") {
          let obj = {};
          await response.data.PermissionData.map((v) => {
            obj[v.Permission?.title] = v.Permission;
          });
          console.log(obj);
         setPermissions(obj)
        }
      })
      .catch((error) => console.log(error.message));
  }
  // if (localStorage.getItem("UserData") === null) {
  //   return <Redirect to={'/signin'} />;
  // }
  // var retrievedData =  localStorage.getItem('UserData');
  // var data = JSON.parse(retrievedData);
  // if (data.token == null) {
  //   return <Redirect to={'/signin'} />;
  // }
  if(permissions == null) {
    return <Spinner/>
  } else {
    return (
      <div className={classes.root}>
        <AppBar position="static">
          <AntTabs
            style={{color:Colors.buttonTextColor}}
            //style={{backgroundColor:"black"}}
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
          >
            <Tab
              style={{textTransform:"none",fontSize:17,backgroundColor: value==0 ? Colors.activeBarColor : "transparent"}}
              
              label="Template"
              {...a11yProps(0)}
              component={Link}
              to="/template/list"
            />
            <Tab
              style={{textTransform:"none",fontSize:17,backgroundColor: value==1 ? Colors.activeBarColor : "transparent"}}
              label="Response"
              {...a11yProps(1)}
              component={Link}
              to="/template/response"
            />
          </AntTabs>
        </AppBar>
        <Switch>
          <Route path="/template/list" component={Templateemail} />
          <PrivateRoute  permission={
              // permissions["Admin"]
              //   ? true
              //   : permissions["Manage Response Sets"]
              //   ? true
              //   : false
              true
            } path="/template/response" component={TemplateResponse} />
        </Switch>
      </div>
    );
  }
 
}

const PrivateRoute = ({ component: Component, permission, ...rest }) => {
  
return (
  <Route
    {...rest}
    render={(props) =>
      permission === true ? (
        <Component {...props} />
      ) : (
        <Redirect to="/not-permitted" />
      )
    }
  />
);
};